export const infoAlert = (message) => {
    return (
        <div className="alert alert-info" role="alert">
            <h6>{message}</h6>
        </div>

    )
}
export default {infoAlert};